const SUPPORTED_LANGUAGES = ["text", "javascript", "typescript", "jsx", "tsx", "python", "java", "cpp", "csharp", "html", "css", "scss", "json", "sql", "bash", "shell", "markdown", "yaml", "xml"];
const DEFAULT_LANGUAGE = "text";
export {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES
};
